import { ModuleType } from 'global-services/constants/OhsObject';

import { getConfigValue, setPermissions } from '../OhsConfigServices';
import OhsModulePermissions from './OhsInjuryManagementPermissions';
import OhsFileBoxConfig from '../filebox/OhsFileBoxConfig';
import { OhsModuleCategory } from '../OhsModuleCategory';

class OhsInjuryManagementConfig {
  TITLE: string;

  PERMISSIONS: OhsModulePermissions;

  MORPH_PERMISSIONS: OhsModulePermissions;

  TYPE = ModuleType.Injury;

  fileboxConfig?: OhsFileBoxConfig;

  CATEGORY_LIST: OhsModuleCategory[];

  STATUS_LIST: { title: string; options: any[] }[];

  constructor(config: any, fileboxConfig?: any) {
    this.TITLE = getConfigValue(config, 'TITLE');
    this.PERMISSIONS = new OhsModulePermissions(false);
    this.MORPH_PERMISSIONS = new OhsModulePermissions(false);
    this.CATEGORY_LIST = getConfigValue(config, 'CATEGORY_LIST');
    this.STATUS_LIST = getConfigValue(config, 'STATUS_LIST');
    setPermissions(this.PERMISSIONS, getConfigValue(config, 'PERMISSIONS'));
    setPermissions(this.MORPH_PERMISSIONS, getConfigValue(config, 'MORPH_PERMISSIONS'));

    if (fileboxConfig) {
      this.fileboxConfig = new OhsFileBoxConfig(fileboxConfig);
    }
  }
}

export default OhsInjuryManagementConfig;
